import { render, staticRenderFns } from "./PlayerTagsSelect.vue?vue&type=template&id=4a86dca3"
import script from "./PlayerTagsSelect.vue?vue&type=script&lang=js"
export * from "./PlayerTagsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports